
// 配置中心
import Log from '../view/log'
import ConfigCenterNav from '../view/ConfigCenter/ConfigCenterNav'
import ConfigBasic from '../view/ConfigCenter/ConfigBasic/ConfigBasic'
import wxAccountManage from '../view/ConfigCenter/wxAccountConfig/wxAccountManage'
import wxAccountAdd from '../view/ConfigCenter/wxAccountConfig/wxAccountAdd'
import wxAccountModify from '../view/ConfigCenter/wxAccountConfig/wxAccountModify'


export default [


    /* 配置中心 */
    {
        path: '/config_center/config_basic',
        name: 'config-basic',
        components: {
            default: ConfigCenterNav,
            a: ConfigBasic
        }
    },
    {
        path: '/config_center/wx_account_manage',
        name: 'wx-account-manage',
        components: {
            default: ConfigCenterNav,
            a: wxAccountManage
        }
    },
    {
        path: '/config_center/wx_account_add',
        name: 'wx-account-add',
        components: {
            default: ConfigCenterNav,
            a: wxAccountAdd
        }
    },
    {
        path: '/config_center/wx_account_modify',
        name: 'wx-account-modify',
        components: {
            default: ConfigCenterNav,
            a: wxAccountModify
        }
    },
    /* 配置中心 */

    // 配置中心操作日志
    {
        path: '/config_center_log',
        name: 'config-center-log',
        components: {
            default: ConfigCenterNav,
            a: Log
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/ConfigCenter.js